import Modal from 'components/Modal/Modal.react';
import styles from 'components/Modal/Modal.scss';
import ParseApp from 'lib/ParseApp';
import PushCerts from 'components/PushCerts/PushCerts.react';
import React from 'react';

import PropTypes from 'prop-types';

export default class AppleCerts extends React.Component {
  constructor() {
    super();

    this.state = {
      certificates: undefined,
      deletePending: null,
      deleteProgress: null,
      error: null,
    };

    this.handleKey = this.handleKey.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
  }

  componentDidMount() {
    document.body.addEventListener('keydown', this.handleKey);

    this.mounted = true;
    this.context.currentApp.getAppleCerts().then(({ certs }) => {
      if (this.mounted) {
        const certificates = certs.filter(f => f.type !== "push-apple-token");
        this.setState({ certificates });
      }
    });
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKey);
    this.mounted = false;
  }

  onCloseClick() {
    this.setState({ deletePending: null });
  }

  handleDelete(id) {
    this.setState({ deletePending: id, error: null });
  }

  handleKey(e) {
    const keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.onCloseClick(this);
        break;
    }
  }

  handleUpload = (props) => {
    const { file, type } = props;
    const { certificates } = this.state;

    this.context.currentApp.uploadAppleCert({ file, type }).then(({ cert, error }) => {
      if (cert) {
        Intercom('trackEvent', 'upload_ios_certificate');
        // Wait a bit to let openshift catch up
        setTimeout(() => {
          certificates.unshift(cert);
          this.setState({ uploadPending: false });
          location.reload();
        }, 3000);
      }

      if (error) {
        this.setState({
          uploadPending: false,
          error,
          // note: { type: 'error', message: error }
        });
      }
    });

    this.setState({ uploadPending: true, error: null });
  }

  render() {
    const { certificates } = this.state;

    // if (!certificates || certificates.length === 0) return null;

    return (
      <div>
        <PushCerts
          certs={certificates}
          error={this.state.error}
          uploadPending={this.state.uploadPending}
          onUpload={this.handleUpload}
          onDelete={this.handleDelete.bind(this)} />
        {this.state.deletePending === null ? null :
          <Modal
            type={Modal.Types.DANGER}
            title="Delete this certificate"
            subtitle="Be careful, this action cannot be undone!"
            cancelText="Cancel"
            confirmText="Delete"
            progress={this.state.deleteProgress}
            onCancel={this.onCloseClick.bind(this)}
            onConfirm={() => {
              this.setState({ deleteProgress: true });
              const id = this.state.deletePending;
              this.context.currentApp.deleteAppleCert(id).then(() => {
                for (let i = 0; i < certificates.length; i++) {
                  if (certificates[i].id === id) {
                    certificates.splice(i, 1);
                    return this.setState({ deletePending: null, deleteProgress: false });
                  }
                }
              }, (err) => {
                this.setState({ deletePending: null, error: err.error });
              });
            }}>
            <p className={styles.only}>Notifications will no longer be sent to <strong>{this.context.currentApp.slug}</strong>.</p>
          </Modal>
        }
      </div>
    );
  }
}

AppleCerts.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp),
};
